// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tldr__wrapper .tldr__item[data-v-3ebdcabb]{color:#5a585d;list-style-type:none;margin-bottom:5px;font-weight:400;position:relative}.tldr__wrapper .tldr__item[data-v-3ebdcabb]:last-child{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
